export default "__VITE_ASSET__BO168yPZ__"